import req from "@/utils/axios.js";
 const ossurl = import.meta.env.VITE_OSS_URL;
 const baseUrl = import.meta.env.VITE_API_BASE_URL;
export default {
    //检查图片地址
    getImageUrl(url) {
      if (!url) return '';
      // 检查是否已经有http或https前缀
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url;
      }
      // 如果没有前缀，添加oss域名
      return ossurl + url;
    },
    // 上传文件
    uploadFile(file) {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('dir_name', 'wxmini_upload');
            formData.append('firm_uuid', 6);

            fetch(baseUrl + 'file/s3', {
                method: 'POST',
                body: formData
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('网络错误');
                }
                return response.json();
            })
            .then(data => {
                if (data.code === 200) {
                    resolve(data);
                } else {
                    reject(new Error(data.msg || '上传失败'));
                }
            })
            .catch(err => {
                reject(err);
            });
        });
    },
}